<template>
  <q-dialog
    content-class="detailDialog"
    :value="show"
    persistent
    position="bottom"
  >
    <q-card class="no-border-radius detailCard">
      <q-card-section class="q-pa-none">
        <q-banner dense inline-actions class="q-px-md q-py-md">
          <span class="font-size-14 text-weight-bolder">
            {{ $t('details.selectVariant') }}
          </span>
          <template #action>
            <q-btn size="xs" unelevated round flat @click="$emit('close')">
              <q-icon size="16px" name="font:dm-close" />
            </q-btn>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section v-if="detail" class="q-pa-none">
        <q-card flat class="productOption q-pb-md q-px-none q-pt-sm">
          <q-card-section class="q-px-md q-mb-md q-py-none productName">
            <div class="ellipsis font-size-14 line-height-18">
              {{ detail.productName }}
            </div>
          </q-card-section>
          <q-card-section
            v-if="detail.optParams"
            align="between"
            class="q-px-md q-py-none"
          >
            <div
              v-for="(opt, optInedx) in detail.showName"
              :key="`${opt}-${optInedx}`"
              class="text-theme-gray"
            >
              . {{ opt.name }}
            </div>
          </q-card-section>
          <q-card-actions align="between" class="q-px-md q-py-none q-mt-md">
            <span class="text-theme-gray">
              +
              {{
                $n(
                  detail.memberPrice + detail.modifierPrice,
                  'currency',
                  'id-ID',
                )
              }}
            </span>
          </q-card-actions>
          <q-card-section class="q-px-none q-mt-xs q-pb-none">
            <Modifiler v-model="params" :original="modifiers" />
          </q-card-section>
        </q-card>
      </q-card-section>
      <q-card-section class="q-pa-none addBtn q-pb-md">
        <div class="counter">
          <q-btn
            :disabled="detail.quantity <= (min ? min : 0)"
            unelevated
            round
            size="xs"
            color="primary"
            icon="remove"
            @click="handleReduceNumber"
          />
          <q-input
            v-model.number="detail.quantity"
            type="number"
            readonly
            class="counterText"
          />
          <q-btn
            :disabled="
              detail.quantity >= (max ? max : Infinity) || detail.disable
            "
            unelevated
            round
            size="xs"
            color="primary"
            icon="add"
            @click="handleAddNumber"
          />
        </div>
      </q-card-section>
      <q-card-section class="confirm">
        <q-btn
          unelevated
          no-caps
          class="full-width border-radius-8"
          color="primary"
          :label="$t('details.saveChanges')"
          @click="handleConfirm"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import _ from 'lodash';
import { expandArr } from 'src/utils/loadsh';
import Modifiler from './Modifiler.vue';

export default {
  components: { Modifiler },
  model: {
    prop: 'show',
    event: 'close',
  },
  props: {
    show: {
      type: Boolean,
      default: () => {},
    },
    product: {
      type: Object,
      default: () => {},
    },
    max: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detail: {},
      modifiers: [],
      params: [],
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.detail = _.cloneDeep(this.product);
        this.detail.modifierPrice = 0;
        this.detail.productName = this.detail.product.name;
      } else {
        this.detail = {};
      }
    },
    product: {
      handler(val) {
        if (!_.isEmpty(val)) {
          this.detail = _.cloneDeep(val);
          this.detail.modifierPrice = 0;
          this.detail.productName = this.detail.product.name;
          this.modifiers = val.product.modifiers;
        }
      },
      immediate: true,
      deep: true,
    },
    params: {
      handler(val) {
        if (!_.isEmpty(val)) {
          this.detail.optParams = val;
          const obj = expandArr(val);
          let price = 0;
          obj.forEach(item => {
            price += item.price;
          });
          this.detail.modifierPrice = price;
          this.detail.showName = obj;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleConfirm() {
      const { modifiers } = this.detail.product;
      this.params.forEach((item, index) => {
        modifiers[index].value = item;
      });
      const isPass = this.checkRequired(modifiers);
      if (isPass) {
        this.$emit('getParams', this.params);
        this.$emit('close');
      }
    },
    checkRequired(modifiers) {
      let Switch = true;
      for (let i = 0; i < modifiers.length; i += 1) {
        if (modifiers[i].min) {
          if (_.isEmpty(modifiers[i].value)) {
            this.getErrTips(modifiers[i].name, modifiers[i].min);
            Switch = false;
            break;
          }
          const isArray = Array.isArray(modifiers[i].value);
          if (isArray && modifiers[i].value.length < modifiers[i].min) {
            this.getErrTips(modifiers[i].name, modifiers[i].min);
            Switch = false;
            break;
          }
        }
      }
      return Switch;
    },
    handleAddNumber() {
      this.detail.quantity += this.detail.bundleQuantity;
      this.$emit('getQuantity', this.detail.quantity);
    },
    handleReduceNumber() {
      this.detail.quantity -= this.detail.bundleQuantity;
      this.$emit('getQuantity', this.detail.quantity);
      if (this.detail.quantity <= 0) this.$emit('close');
    },
    getErrTips(name, min) {
      this.$q.notify({
        message: this.$t('details.verifyRequired', { name, min }),
        spinner: false,
        position: 'bottom',
        classes: 'glossy',
        type: 'ongoing',
        timeout: 1500,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.detailDialog {
  .detailCard {
    background: #f3f4f6;
    position: relative;
    padding-bottom: 60px;
  }
  .addBtn {
    background: #ffffff;
  }
  .counter {
    display: flex;
    justify-content: center;
    align-items: center;
    :deep(.q-btn) {
      width: 24px;
      height: 24px;
      .q-btn__wrapper {
        min-width: unset;
        min-height: unset;
        width: 25px;
        height: 25px;
      }
      .q-icon {
        font-size: 18px;
        // font-weight: bold;
      }
    }
    :deep(.counterText) {
      .q-field__control {
        &:before {
          display: none;
        }
        height: 24px;
        width: 32px;
        input {
          color: $black;
          font-weight: bold;
          font-size: 16px;
          text-align: center;
          padding: 0;
        }
      }
    }
  }
  .confirm {
    background: #f3f4f6;
    padding: 12px 16px;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    // 双数高度 会突然出现类似边框的莫名奇妙的东西 单数就消失了 淦
    height: 59px;
  }
}
</style>
